












































































































import { cloneDeep, snakeCase } from 'lodash'
import moment from 'moment'
import Vue from 'vue'
import { Component, Emit, Prop, Watch } from 'vue-property-decorator'

import PostApi from '../../../../../../plugins/AdminTemplate/includes/logic/Api/PostApi'
import { PropertyFieldType } from '../../../../../BotProperties/components/Properties/types'
import { PropertiesHelper, PropertyValueType, UserProfileConfig } from '../../../../../BotUserProfile/types'
import { UserProfileProperties, UserProfileProperty } from '../../../../../BotUsers/components/Users/types'
import FileDescriptorsPreview from '../../../../../File/FilesList/FileDescriptorsPreview.vue'
import MediaUploader from '../../../../../MediaUploader/MediaUploader.vue'
import UploadMediaDescriptors from '../../../../../MediaUploader/UploadMediaDescriptors.vue'
import FieldTitle from '../../../../../Pi/components/FieldTitle.vue'
import Picker from '../../../../../Picker/Picker.vue'
import { PickerFormat } from '../../../../../Picker/types'
import ZoomableImage from '../../../../../ZoomableImage/ZoomableImage.vue'
import { TableProperty } from '../../Tabs/ProfileProperties.vue'

@Component({
  data() {
    return {
      PropertyFieldType,
      moment,
      snakeCase,
      PostApi
    }
  },
  components: {
    FileDescriptorsPreview,
    UploadMediaDescriptors,
    Picker,
    FieldTitle,
    MediaUploader,
    ZoomableImage
  }
})
export default class RowTableProperty extends Vue {
  @Prop() value!: PropertyValueType

  @Prop() type!: PropertyFieldType

  @Prop() propType!: string

  @Prop() name!: string

  @Prop() id!: number

  @Prop() properties!: UserProfileProperties

  @Prop() userId!: number

  @Prop() setProperty!: PropertiesHelper['setProperty']

  @Prop() selectedProperty!: TableProperty

  @Prop() updating!: boolean

  @Prop() mediaTargetId!: UserProfileConfig['mediaTargetId']

  propCopy: UserProfileProperty | null = null

  isActive = false

  isModalOpen = false

  @Watch('selectedProperty')
  onSelectedPropertyChange(val: UserProfileProperty['property']) {
    this.isActive = val?.id === this.id;
  }

  @Watch('updating')
  onUpdatingChange(state: boolean) {
    if (!state && this.selectedProperty?.id === this.id) {
      this.setPropertyHandler()
    }
  }

  @Emit()
  resetEditing() {
    return null;
  }

  get pickerFormat(): PickerFormat | null {
    if (this.propCopy) {
      if (this.propCopy.property.type === PropertyFieldType.Date) {
        return PickerFormat.Date
      } else if (this.propCopy.property.type === PropertyFieldType.Time) {
        return PickerFormat.Time
      } else {
        return PickerFormat.DateTime
      }
    }
    return null
  }

  get isChange(): boolean {
    return !!this.propCopy && this.propCopy.value !== this.selectedProperty.value
  }

  onOk() {
    this.setPropertyHandler()
  }

  inputValidator(event: any): void {
    const value = event.originalTarget.value as string

    if (this.propCopy && this.propCopy.property.type === PropertyFieldType.Phone) {
      const regExp = new RegExp(/^[+\d()-]+$/)

      if (regExp.test(value)) {
        this.propCopy.value = value
      }
    } else {
      if (this.propCopy) {
        this.propCopy.value = value
      }
    }
  }

  getProp(id: number): UserProfileProperty | undefined {
    const custom = this.properties.custom.find((p) => p.property.id === id)
    const system = this.properties.system.find((p) => p.property.id === id)

    if (custom) {
      return custom
    }

    if (system) {
      return system
    }

    return undefined
  }

  setPropertyHandler(): void {
    if (this.isChange) {
      this.setProperty(this.userId, this.id, this.propCopy!.value)
        .then((res) => {
          this.changeProp(res.value, this.id)
        })
        .catch(() => {
          this.resetEditing()
          this.setProp()
        })
        .finally(() => {
          this.isActive = false
        })
    } else {
      this.resetEditing()
      this.isActive = false
    }
  }

  @Emit('changeProp')
  changeProp(value: PropertyValueType, id: number): { value: PropertyValueType, id: number } {
    return { value, id }
  }

  setProp(): void {
    const prop = this.getProp(this.id)

    if (prop) {
      this.propCopy = cloneDeep(prop)
    }
  }

  mounted(): void {
    this.setProp()
  }
}
